import { VariantType } from 'notistack';

export const NOTIFICATION_TYPES = {
  ERROR: 'error' as VariantType,
  SUCCESS: 'success' as VariantType,
  WARNING: 'warning' as VariantType,
  INFO: 'info' as VariantType,
} as const;

export type TNotificationItem = {
  message: string;
  type: VariantType;
};

export type TNotificationState = {
  notification: TNotificationItem | null;
};
